import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../../lib/actionTypes.es6';
import * as actions from './actions';
import { getPolicyCancellationRequests, updatePolicyCancellationRequest, updatePolicyCancellationInProgress } from '../../../../lib/requests.es6';
import { GAloggerException } from '../../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../../lib/access.es6';

export function* getPolicyCancellationRequestsWatcher() {
  for (;;) {
    const request = yield take(types.GET_POLICY_CANCELLATION_REQUESTS_REQUEST);
    try {
      const response = yield call(getPolicyCancellationRequests, request.payload);
      yield put(actions.getPolicyCancellationRequestsSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getPolicyCancellationRequestsFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updatePolicyCancellationWatcher() {
  for (;;) {
    const request = yield take(types.UPDATE_POLICY_CANCELLATION_REQUEST);
    try {
      const response = yield call(updatePolicyCancellationRequest, request.payload);

      // After successful approval/rejection, clear is_cancellation_in_progress flag
      try {
        var existingDetails = request.payload.additional_details || {};
        yield call(updatePolicyCancellationInProgress, {
          policy_guid: request.payload.policy_guid,
          additional_details: Object.assign({}, existingDetails, {
            is_cancellation_in_progress: false,
          }),
        });
      } catch (progressError) {
        GAloggerException(progressError);
      }

      yield put(actions.updatePolicyCancellationSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.updatePolicyCancellationFailure(errorMessage));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
